<template>
    <form class="form" @submit.prevent="handleSubmit">
        <div class="form__group inline-submit">
            <label for="search_query" class="form__label">Link MADD/Opportunity</label>
            <input
                id="search_query"
                name="query"
                class="form__control"
                v-model="formData.query"
                placeholder="Search for an existing MADD/Opportunity within this sector..."
                @input="handleTextInput"
                v-validate
                required
                :disabled="$wait.is('search-results')"
            />
            <button class="btn btn--icon btn--primary" :disabled="$wait.is('search-results')">
                <Spinner v-if="$wait.is('search-results')" />
                <SvgIcon v-else icon="filled-opposearch" classes="filled" />
            </button>
            <div class="form__validation"></div>
        </div>
        <div v-if="formData.query && formData.query.length" class="search-results">
            <v-wait for="search-results">
                <ul v-if="!itemsIsEmpty" class="search-results__list">
                    <li v-for="item in items">
                        <Result
                            :item="item"
                            :is-selected="selectedItem && item.id === selectedItem.id"
                            v-on:on-selected="handleSelection"
                        />
                    </li>
                </ul>
                <span v-else>
                    No Results Found
                </span>
            </v-wait>
        </div>
    </form>
</template>
<script>
import debounce from 'debounce';
import API from '@api';
import SvgIcon from '@components/SvgIcon';
import Spinner from '@components/Spinner';
import Result from '@components/SearchModal/Result';

export default
{
    name: 'SearchModalForm',
    computed: {},
    components: {
        Spinner,
        SvgIcon,
        Result
    },
    props: {
        sectorId: {
            type: Number,
            required: true,
        },
        preSelectedItem: {
            type: Number,
        },
    },
    data: () => ({
        items: [],
        itemsIsEmpty: false,
        selectedItem: null,
        formData: {
            query: '',
        },
    }),
    methods: {
        handleTextInput: () => {
        },
        handleSubmit: () => {
        },
        async getData() {
            this.items = [];
            this.selectedItem = null;

            try {
                this.itemsIsEmpty = false;
                this.$wait.start('search-results');

                if(this.formData.query && this.formData.query.length) {
                    this.items = await API.searchRelatedItems(this.formData.query, this.sectorId);
                    this.itemsIsEmpty = !this.items.length;
                }
            } catch(err) {
                console.warn(`[RelatedItemSearch] ${ err.message }`);
            } finally {
                this.$wait.end('search-results');
            }
        },
        handleSelection(newId) {
            this.selectedItem = newId;
        },
    },
    watch: {
        selectedItem: function(newValue) {
            this.$emit( "change", newValue );
        }
    },
    created() {
        this.handleSubmit = debounce(
            this.getData.bind(this),
            500,
        );
        this.handleTextInput = debounce(
            this.handleSubmit.bind(this),
            500,
        );
    },
}
</script>

<style lang="scss" scoped>
.form {
    justify-content: flex-start;
    text-align: left;
}

.form__control {
    background-color: #F1F1F1;
    border: 0.1rem solid #F1F1F1;
    color: #657787;
    border-radius: 1.8rem;

    &::placeholder {
        opacity: 1;
        color: #747484;
    }

    &:-webkit-autofill {
        box-shadow: inset 0 0 0 9999px #F1F1F1;
        color: #657787;
    }
}

.search-results {
    margin-top: 2rem;
    width: 100%;


    .search-results__list {
        margin: 0 -2rem;
        padding: 0 2rem 1rem;
        max-height: 19rem;
        overflow-y: scroll;
        list-style: none;
    }
}
</style>
